import React from 'react';
import type { IconProps } from '../types';

export const ContentPrev = (props: IconProps) => (
  <svg
    width="6px"
    height="10px"
    viewBox="0 0 6 10"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="Icons"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Artboard"
        transform="translate(-435, -343)"
        fill="currentColor"
      >
        <polygon
          id="chevron-prev"
          transform="translate(438, 348) rotate(90) translate(-438, -348)"
          points="438 351 433 345.736842 433.7 345 438 349.526316 442.3 345 443 345.736842"
        ></polygon>
      </g>
    </g>
  </svg>
);

export default ContentPrev;
